module.exports = __webpack_public_path__ + "img/emoji_025.d27a73cf.png";